
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-finance",
      function () {
        return require("private-next-pages/car-finance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car-finance"])
      });
    }
  